var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81273 4.5C9.81273 5.24592 9.51641 5.96129 8.98896 6.48874C8.46152 7.01618 7.74615 7.3125 7.00023 7.3125C6.25431 7.3125 5.53893 7.01618 5.01149 6.48874C4.48404 5.96129 4.18773 5.24592 4.18773 4.5C4.18773 3.75408 4.48404 3.03871 5.01149 2.51126C5.53893 1.98382 6.25431 1.6875 7.00023 1.6875C7.74615 1.6875 8.46152 1.98382 8.98896 2.51126C9.51641 3.03871 9.81273 3.75408 9.81273 4.5ZM1.37598 15.0885C1.40008 13.6128 2.00323 12.2056 3.05536 11.1705C4.10749 10.1354 5.52429 9.55535 7.00023 9.55535C8.47616 9.55535 9.89296 10.1354 10.9451 11.1705C11.9972 12.2056 12.6004 13.6128 12.6245 15.0885C10.86 15.8976 8.94134 16.3151 7.00023 16.3125C4.99323 16.3125 3.08823 15.8745 1.37598 15.0885Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e9afcd8624827d17ddf0abba9c935d43.svg";
export { ForwardRef as ReactComponent };